module.exports = __webpack_public_path__ + "img/热泵及蓄冷系统.d3ac85ff.png";